// extracted by mini-css-extract-plugin
export var fullHeightState = "_20-7";
export var headerCell = "_20-1";
export var loadingStateCell = "_20-4";
export var rowWrapper = "_20-3";
export var standaloneTable = "_20-8";
export var standaloneTableWithBodyFill = "_20-9";
export var stateCell = "_20-5";
export var table = "_20-0";
export var tableBodyFiller = "_20-6";
export var white = "_20-2";